var locale = {
  locale: "en-US",
  common: {
    colon: ": ",
    all: "All",
    noOptions: "No Options"
  },
  DatePicker: {
    Sun: "Su",
    Mon: "Mo",
    Tue: "Tu",
    Wed: "We",
    Thu: "Th",
    Fri: "Fr",
    Sat: "Sa"
  },
  DateRange: {
    oneHour: "Last Hour",
    today: "Last Day",
    oneWeek: "Last Week",
    oneMonth: "Last Month",
    oneYear: "Last Year",
    customized: "Custom",
    noData: "No Data",
    invalidDate: "Invalid Date",
    time: "Time",
    startTime: "Start Time",
    endTime: "End Time",
    startDate: "Start Date",
    endDate: "End Date",
    clear: "Clear",
    cancel: "Cancel",
    apply: "Apply"
  },
  Empty: {
    noData: "Turing Robot has found no records.",
    retry: "It encourages you to try again."
  },
  InputEmail: {
    invalidEmail: "Please input valid email address",
    enterMore: "Enter more",
    enterEmail: "Enter email"
  },
  InputPhone: {
    invalidPhone: "Please input valid phone number",
    enterMore: "Enter more",
    enterPhone: "Enter cell phone",
    helperText: "Add 10 digits with no spaces or dashes"
  },
  ProTable: {
    noData: "No Data"
  }
};
export default locale;